export default __webpack_public_path__ + "static/media/nahm.5160643c.gif";